import TRANSLATIONS from "./translations";

export default class TranslationHelper {

  lang = "en";
  constructor() {
    let _this = this;
    _this.lang = document.querySelector('html').getAttribute('lang');
  }

  getWordTag(wordTag) {
    let _this = this;
    if (wordTag in TRANSLATIONS && _this.lang in TRANSLATIONS[wordTag]) {
      return TRANSLATIONS[wordTag][_this.lang];
    }

    return null;
  }

  getText(wordTag) {
    let _this = this;
    let word = _this.getWordTag(wordTag);
    if (word && "text" in word && word.text && word.text.length > 0) {
      return word.text;
    }
    else {
      return wordTag;
    }
  }

  getAbbreviation(wordTag) {
    let _this = this;
    let word = _this.getWordTag(wordTag);
    if (word && "abbreviation" in word && word.abbreviation && word.abbreviation.length > 0) {
      return word.abbreviation;
    }
    else {
      return wordTag;
    }
  }
}

const translationHelperObj = new TranslationHelper();
export { translationHelperObj };